var _defs, _polygon, _path, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _path2, _path3, _polygon8, _polygon9, _path4, _polygon0, _polygon1, _path5, _polygon10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKatrinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250.11 55.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e31f2b;}.cls-2{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 0 250.1 0 250.1 55.66 0 55.66 0 0 0 0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M193.45,82l-3-12.84h-15L167,82l-1.09,1.66L164.65,82,160,75.67l8.32-6.54h-10l-6.18,4.77,1-4.77-8.47,0L142,82l-.41,1.91-.14.55-.2.7h-2.37L138,89.9h13.46l.92-4.77h-2.6l.78-3.16,1.05-4.28L154.47,82l2.13,3.16h-2.23l-.94,4.77H175.1l1-4.78h-2.57l1.55-2.67h9.68l.63,2.68H182.1l-.95,4.77h13l1-4.78h-1Zm-15.2-4.9L182,70.61l1.56,6.46Z",
    transform: "translate(-97 -49.07)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "92.05 13.84 82.47 13.84 79.37 18.57 93.12 18.57 92.05 13.84"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "75.24 13.84 61.74 13.84 60.81 18.57 74.3 18.57 75.24 13.84"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "59.88 13.84 46.39 13.84 45.45 18.57 58.95 18.57 59.88 13.84"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "167.31 13.84 153.26 13.84 152.17 18.57 166.19 18.57 167.31 13.84"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "181.62 13.84 169.1 13.84 168.11 18.57 183.31 18.57 181.62 13.84"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "103.36 20.09 96.9 20.09 96.11 23.88 102.57 23.88 103.36 20.09"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M304.25,65.37a1.25,1.25,0,0,0,1.08-1.25c0-1.2-1-1.47-2-1.47h-1.72V68h.83V65.66h.7c.28,0,.56,0,.76.22a2,2,0,0,1,.3,1.12c0,.31.12.65.18,1h1a7.93,7.93,0,0,1-.31-1.54C305.07,65.84,305,65.52,304.25,65.37Zm-.91-.54h-.87V63.48h1c.66,0,.84.2.84.6S304.12,64.81,303.34,64.83Z",
    transform: "translate(-97 -49.07)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M240.13,62.9H195.45l-1.18,4.73h51C244.37,64.42,240.68,62.8,240.13,62.9Z",
    transform: "translate(-97 -49.07)"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "186.74 18.57 198.69 18.57 199.78 13.84 187.79 13.84 186.74 18.57"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "186.84 29.48 183.8 20.11 170.01 20.11 167.09 32.9 166.36 36.14 164.08 36.14 163.16 40.89 174.83 40.89 175.94 36.1 173.09 36.1 173.78 32.9 175.89 23.06 179.13 32.9 181.76 40.87 191.57 40.89 193.39 32.9 196.31 20.08 189.03 20.08 186.84 29.48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M303.43,60.87a4.51,4.51,0,1,0,4.49,4.49A4.49,4.49,0,0,0,303.43,60.87Zm0,8.21a3.71,3.71,0,1,1,3.7-3.72A3.72,3.72,0,0,1,303.43,69.08Z",
    transform: "translate(-97 -49.07)"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "163.08 20.03 154.84 20.03 151.95 32.9 151.23 36.09 148.17 36.09 147.15 40.89 161.12 40.9 162.23 36.14 159.38 36.14 160.12 32.9 163.08 20.03"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "123.83 20.09 117.16 20.09 116.36 23.88 123.03 23.88 123.83 20.09"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M241.86,82c-.42-2.68-1.17-4.39-2.26-5.15,3.73-1.6,5.61-4,5.64-7.72h-9.6c2,3.38-.66,5.49-6.18,5l1.14-5h-8.47L219.22,82l-.72,3.17h-2.64l-1.07,4.77H228.7l1.09-4.75h-2.63l.7-3.19.6-2.69c2.62.1,3.68-.61,4.39,2.69h0c.11.55.23,1.21.33,2l.8,6h8.9l1-4.81h-1.72C242.11,84,242,82.9,241.86,82Z",
    transform: "translate(-97 -49.07)"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.53 20.04 106.19 20.04 103.25 32.9 102.52 36.07 99.65 36.07 98.52 40.85 113.43 40.85 114.49 36.1 112.91 36.11 110.96 36.11 111.67 32.9 114.53 20.04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKatrinLogo);
export default __webpack_public_path__ + "static/media/katrin_logo.c2bb69aa9bb4bb01ea7c186ec7353ced.svg";
export { ForwardRef as ReactComponent };